<script setup>
import {computed, onMounted, ref} from "vue";
import PageTitle from "@/components/common/PageTitle.vue";
import NavCard from "@/components/common/NavCard.vue";
import { useI18n } from 'vue-i18n';
import { useRoute } from "vue-router";
import {getAvailableActionsForRoute} from "@/services/api/permissionManagement.js";
import { getSettingsRoute } from "@/utils/settingsRoutes.js";

const { t } = useI18n();
const route = useRoute();
const actionsPermission = ref(null);
const isLoaded = ref(false);
const actionsUsers = ref(null);
const actionsCorp = ref(null);
const settingsBaseRoute = computed(() => getSettingsRoute('/settings', route));
const companySetupRoute = computed(() => {
    const baseRoute = route.path.startsWith('/rhdigital/settings')
        ? '/rhdigital/company-setup'
        : '/company-setup';

    return `${baseRoute}?redirect=${encodeURIComponent(settingsBaseRoute.value)}`;
});


const breadcrumbs = computed(() => {
    const items = [
        { label: t("components.settings.index.pageTitle"), to: settingsBaseRoute.value }
    ];
    return items;
});

const cards = computed(() => {

    const baseCards = [
        {
            // Sempre visível: é aqui que se cadastra o registry de aplicações, e
            // numa plataforma recém-instalada o catálogo de permissões pode nem
            // ter o nó desta rota. Quem recusa de fato é a API.
            title: "components.settings.index.applications",
            subtitle: "components.settings.index.applicationsDescription",
            icon: "apps",
            routeName: `${settingsBaseRoute.value}/applications`,
        },
        {
            title: "components.settings.index.changeCorporation",
            subtitle: "components.settings.index.selectDesiredCorporation",
            icon: "business",
            routeName: route.path.startsWith('/rhdigital/settings')
                ? "/rhdigital/settings/corporation-selection"
                : "/corporation-selection",
        },
    ];

    if (actionsPermission.value?.list?.length) {
        baseCards.unshift({
            title: "components.settings.index.permissionManagement",
            subtitle: "components.settings.index.permissionManagementDescription",
            icon: "lock_person",
            routeName: `${settingsBaseRoute.value}/permission-management`,
        });
    }

    if (actionsUsers.value?.list?.length) {
        baseCards.unshift({
            title: "components.settings.index.userManagement",
            subtitle: "components.settings.index.userManagementDescription",
            icon: "manage_accounts",
            routeName: `${settingsBaseRoute.value}/users`,
        });
    }

    if (actionsCorp.value?.create?.length || actionsCorp.value?.create) {
        baseCards.unshift({
            title: "components.settings.index.createCorporation",
            subtitle: "components.settings.index.createCorporationDescription",
            icon: "domain_add",
            routeName: companySetupRoute.value,
        });
    }

    if (actionsCorp.value?.edit?.length || actionsCorp.value?.edit) {
        baseCards.unshift({
            title: "components.settings.index.editCorporation",
            subtitle: "components.settings.index.editCorporationDescription",
            icon: "domain",
            routeName: `${companySetupRoute.value}&mode=edit`,
        });
    }

    return baseCards;
});

onMounted(async  () => {
    try {
        actionsPermission.value = await getAvailableActionsForRoute("Resources/Settings/Permission Management");
        actionsUsers.value = await getAvailableActionsForRoute("Resources/Settings/Users");
        actionsCorp.value = await getAvailableActionsForRoute("Resources/Settings/Corp");

    } catch (err) {
        console.error("Error Permissions: ", err);
    } finally {
        isLoaded.value = true;
    }
})

</script>
<template>
    <PageTitle v-if="['settings', 'rhdigital-settings'].includes($route.name) && isLoaded" :breadcrumbs="breadcrumbs" />
    <v-card   class="bg-white trezo-card  base-page-height">
        <NavCard :cards="cards" />
    </v-card>
    <router-view />
</template>
